import { FormItem, HintIcon, twMerge } from '@faceup/ui'
import {
  Checkbox as AntdCheckbox,
  type CheckboxProps as AntdCheckboxProps,
  Flex,
} from '@faceup/ui-base'
import type { FieldValues, UseControllerProps } from 'react-hook-form'
import { useCustomController } from '../hooks'
import type { FormItemWrapperProps } from '../typings'

type CheckboxProps<T extends FieldValues> = UseControllerProps<T> &
  Omit<AntdCheckboxProps & FormItemWrapperProps, 'value' | 'checked' | 'defaultValue'> & {
    /** Draws the info icon 2 pixels after the label text instead of 8 pixels after the whole box. */
    isHintAfterLabel?: boolean
  }
export const Checkbox = <T extends FieldValues>({
  isHintAfterLabel = false,
  ...props
}: CheckboxProps<T>) => {
  const {
    formItemProps: { withAsterisk: _withAsterisk, label, hint, ...formItemProps },
    inputProps: { value, onChange: fieldOnChange, ...inputProps },
  } = useCustomController(props)

  return (
    // The label and the hint are drawn inside the row, so the variant only adds the error under it.
    <FormItem {...formItemProps}>
      <Flex gap={isHintAfterLabel ? 2 : 8} align='center'>
        <AntdCheckbox
          {...inputProps}
          className={twMerge(
            isHintAfterLabel && '[&_.ant-checkbox-label]:pe-0',
            inputProps.className
          )}
          value={value}
          checked={value}
          onChange={e => {
            fieldOnChange(e)
            props.onChange?.(e)
          }}
        >
          {label}
        </AntdCheckbox>
        {hint && <HintIcon title={hint} />}
      </Flex>
    </FormItem>
  )
}
